import React from "react";
import { Route, Switch } from "react-router-dom";

import ExceptionPage from "./exception/ExceptionPage";
import NietGevondenPage from "./notFound/NietGevondenPage";
import NoAccessPage from "./noAccess/NoAccessPage";
import ParentHistoryComponent from "./common/ParentHistoryComponent";
import TestPage from "./TestPage";
import DemoPage from "./demo/DemoPage";

//federatie scope
import FederatieOverzichtPage from "./federatie/overzicht/OverzichtPage";
import FederatieLinkOrganisatiePage from "./federatie/linkOrganisatie/LinkOrganisatiePage";

//login scope
import LoginPage from "./login/LoginPage";

//gemeente scope
import GemeenteOverzichtPage from "./gemeente/overzicht/GemeenteOverzichtPage";
import GemeenteLinkOrganisatiePage from "./gemeente/linkOrganisatie/GemeenteLinkOrganisatiePage";

//sportOrganisatie scope
import SportOrganisatieAdresOverzichtPage from "./sportOrganisatie/adres/AdresOverzichtPage";
import SportOrganisatieOrganisatiePage from "./sportOrganisatie/organisatie/OrganisatiePage";
import SportOrganisatieIdentificatiePage from "./sportOrganisatie/identificatie/IdentificatiePage";
import SportOrganisatieInfrastructuurOverzichtPage from "./sportOrganisatie/infrastructuur/InfrastructuurOverzichtPage";
import SportOrganisatieSocialeMediaPage from "./sportOrganisatie/socialeMedia/SocialeMediaPage";
import SportOrganisatieLinkOverzichtPage from "./sportOrganisatie/link/LinkOverzichtPage";
import SportOrganisatieAndereOpmerkingPage from "./sportOrganisatie/andereOpmerking/AndereOpmerkingPage";
import SportOrganisatieDoelgroepenPage from "./sportOrganisatie/doelgroep/DoelgroepenPage";
import SportOrganisatieSporttakkenOverzichtPage from "./sportOrganisatie/sporttak/SporttakOverzichtPage";
import SportOrganisatieEindPage from "./sportOrganisatie/eind/EindPage";
import NiveauInstantiePage from "./sportOrganisatie/niveauInstantie/NiveauInstantiePage";

//nieuweSportclub scope
import NieuweSportclubOrganisatiePage from "./nieuweSportclub/organisatie/OrganisatiePage";
import NieuweSportclubIdentificatiePage from "./nieuweSportclub/identificatie/IdentificatiePage";
import NieuweSportclubAdresPage from "./nieuweSportclub/adres/AdresPage";
import NieuweSportclubSporttakPage from "./nieuweSportclub/sporttak/SporttakPage";
import NieuweSportclubDoelgroepPage from "./nieuweSportclub/doelgroep/DoelgroepPage";
import NieuweSportclubSocialeMediaPage from "./nieuweSportclub/socialeMedia/SocialeMediaPage";
import NieuweSportclubAndereOpmerkingenPage from "./nieuweSportclub/andereOpmerkingen/AndereOpmerkingenPage";
import NieuweSportclubBevestigingPage from "./nieuweSportclub/bevestiging/BevestigingPage";
import NieuweSportclubEindPage from "./nieuweSportclub/eind/EindPage";

export const getRoutes = (match) => {

	return (
		<Switch>
			<Route path={`${match.url}/parentHistory/back`} component={ParentHistoryComponent} />
			<Route path={`${match.url}/parentHistory/path`} component={ParentHistoryComponent} />
			<Route path={`${match.url}/exception`} component={ExceptionPage} />
			<Route path={`${match.url}/noAccess`} component={NoAccessPage} />
			<Route path={`${match.url}/demo`} component={DemoPage} />
			<Route path={`${match.url}/:accountId/demo/new`} render={(props) => <DemoPage {...props} isNew />} />
			<Route path={`${match.url}/testpage`} component={TestPage} />

			{/* federatie scope */}
			<Route exact path={`${match.url}/federatie/overzicht`} component={FederatieOverzichtPage} />
			<Route path={`${match.url}/federatie/linkOrganisatie`} component={FederatieLinkOrganisatiePage} />

			{/* login scope */}
			<Route exact path={`${match.url}/nieuwesportclub`} render={(props) => <LoginPage {...props} isNew />} />
			<Route exact path={`${match.url}/wijzigsportclub`} render={(props) => <LoginPage {...props} isNew={false} />} />
			<Route exact path={`${match.url}/wijzigsportclub/:poId`} render={(props) => <LoginPage {...props} isNew={false} />} />

			{/* gemeente scope */}
			<Route exact path={`${match.url}/gemeente/overzicht`} component={GemeenteOverzichtPage} />
			<Route path={`${match.url}/gemeente/linkOrganisatie`} component={GemeenteLinkOrganisatiePage} />

			{/* sportOrganisatie scope */}
			<Route path={`${match.url}/sportorganisatie/organisatie/:transactieId`} component={SportOrganisatieOrganisatiePage} />
			<Route path={`${match.url}/sportorganisatie/identificatie/:transactieId`} component={SportOrganisatieIdentificatiePage} />
			<Route path={`${match.url}/sportorganisatie/adres/:transactieId`} component={SportOrganisatieAdresOverzichtPage} />
			<Route path={`${match.url}/sportorganisatie/sportinfrastructuur/:transactieId`} component={SportOrganisatieInfrastructuurOverzichtPage} />
			<Route path={`${match.url}/sportorganisatie/sporttakken/:transactieId`} component={SportOrganisatieSporttakkenOverzichtPage} />
			<Route path={`${match.url}/sportorganisatie/doelgroep/:transactieId`} component={SportOrganisatieDoelgroepenPage} />
			<Route path={`${match.url}/sportorganisatie/links/:transactieId`} component={SportOrganisatieLinkOverzichtPage} />
			<Route path={`${match.url}/sportorganisatie/socialemedia/:transactieId`} component={SportOrganisatieSocialeMediaPage} />
			<Route path={`${match.url}/sportorganisatie/extracommentaar/:transactieId`} component={SportOrganisatieAndereOpmerkingPage} />
			<Route path={`${match.url}/sportorganisatie/eind/`} component={SportOrganisatieEindPage} />
			<Route path={`${match.url}/sportorganisatie/niveauinstanties/:transactieId`} component={NiveauInstantiePage} />

			{/* nieuweSportclub scope */}
			<Route exact path={`${match.url}/nieuwesportclub/organisatie`} component={NieuweSportclubOrganisatiePage} />
			<Route exact path={`${match.url}/nieuwesportclub/identificatie`} component={NieuweSportclubIdentificatiePage} />
			<Route exact path={`${match.url}/nieuwesportclub/adres`} component={NieuweSportclubAdresPage} />
			<Route exact path={`${match.url}/nieuwesportclub/sporttak`} component={NieuweSportclubSporttakPage} />
			<Route exact path={`${match.url}/nieuwesportclub/doelgroep`} component={NieuweSportclubDoelgroepPage} />
			<Route exact path={`${match.url}/nieuwesportclub/socialemedia`} component={NieuweSportclubSocialeMediaPage} />
			<Route exact path={`${match.url}/nieuwesportclub/andereOpmerkingen`} component={NieuweSportclubAndereOpmerkingenPage} />
			<Route exact path={`${match.url}/nieuwesportclub/bevestiging`} component={NieuweSportclubBevestigingPage} />
			<Route exact path={`${match.url}/nieuwesportclub/eind`} component={NieuweSportclubEindPage} />


			<Route path={`${match.url}/*`} component={NietGevondenPage} />
		</Switch>
	);
};